<template>
  <div>
    <PageTitle :route="$route" />

    <PageRowWrapper>
      <div class="col-sm-12">
        <ReportList />
      </div>
    </PageRowWrapper>
  </div>
</template>

<script>
  import PageTitle from '@/components/layout/PageTitle'
  import PageRowWrapper from '@/components/layout/PageRowWrapper'
  import ReportList from '@/components/reports/Reports'

  export default {
    name: 'Reports',
    components: {
      PageTitle,
      PageRowWrapper,
      ReportList
    }
  }
</script>